import { AbstractControl, ValidatorFn } from "@angular/forms";

export function numericHyphenValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const numericHyphenRegex = /^[0-9-]+$/;
    const valid = numericHyphenRegex.test(control.value);
    return valid ? null : {'numericHyphen': {value: control.value}};
  };
}
